import Ajax from '../js/common/ajax';

export default {
  list(accountSetsId) {
    return Ajax.get("/note-pad", { accountSetsId });
  },
  save(params = {}) {
    return Ajax.post("/note-pad", params);
  },
  update(params = {}) {
    return Ajax.put("/note-pad", params);
  },
  delete(id, accountSetsId) {
    return Ajax.delete(`/note-pad/${id}`, { accountSetsId });
  },
  uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    return Ajax.post("/note-pad/upload-image", formData, {
      'Content-Type': 'multipart/form-data',
      repeatable: true
    });
  },
  uploadImages(files) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    return Ajax.post("/note-pad/upload-images", formData, {
      'Content-Type': 'multipart/form-data',
      repeatable: true
    });
  },
  getFileUrl(fileUrl) {
    return Ajax.get("/customer-upload/getFileUrl", { fileUrl });
  }
};

